import { gql } from '@apollo/client'

export const USER_SURVEY = gql`
  query UserSurvey(
    $isCompleted: Boolean
    $nonprofitOrgId: Int!
    $type: SurveyType
  ) {
    userSurvey(
      isCompleted: $isCompleted
      nonprofitOrgId: $nonprofitOrgId
      type: $type
    ) {
      completedAt
      id
      orgMissionChange
      orgMissionChangeExplanation
      primaryFunction
      response
      role
      type
      UserSurveyPriority {
        archivedAt
        category
        confidenceLevel
        customPriorities
        id
        rank
        UserSurveyPriorityTopic {
          id
          topic
        }
      }
    }
  }
`
